// #region Imports
import { defineComponent } from "vue";
import core_debounce from 'lodash/debounce';
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-ecommerce-box-search',
    // #endregion
    // #region Properties
    data: () => ({
        recordCount: 0,
        showSearchDropdown: false,
        searchText: null,
        searchData: []
    }),
    props: {
        mode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    // #endregion
    // #region Watch
    watch: {
        '$data.searchText': function (value) {
            this.throttleMethod();
        },
    },
    // #endregion
    // #region Methods
    methods: {
        onfocus() {
            //Mobile
            this.mobileActive();
            //Default
            this.throttleMethod();
        },
        throttleMethod: core_debounce(function () {
            if (!this.searchText || utils.isNullOrEmpty(this.searchText)) {
                this.searchData = [];
                this.showSearchDropdown = false;
                return;
            }
            appHost.api.get('commerce/catalog/quicksearch', { params: { q: this.searchText } })
                .then(e => {
                this.searchData = e.data?.records;
                this.showSearchDropdown = e.data?.records && e.data?.records.length > 0;
                this.recordCount = e.data?.totalRecords ?? 0;
            })
                .catch(e => {
                this.searchData = [];
                this.showSearchDropdown = false;
                this.recordCount = 0;
            });
        }, 200),
        applyButton() {
            this.showSearchDropdown = false;
        },
        goBack() {
            this.mobileDeactive();
        },
        goto(link) {
            //Mobile
            this.mobileDeactive();
            //Reset
            this.searchData = [];
            this.searchText = null;
            this.showSearchDropdown = false;
            this.recordCount = 0;
            //Data
            this.$router.push(link);
        },
        gotoSearch() {
            if (!this.searchText) {
                return;
            }
            //vars
            let tData = this.searchText;
            //Mobile
            this.mobileDeactive();
            //Reset
            this.searchData = [];
            this.searchText = null;
            this.showSearchDropdown = false;
            this.recordCount = 0;
            //Data
            this.$router.push({ path: '/search', query: { q: tData } });
        },
        mobileActive() {
            //Mobile
            if (this.mode !== 'mobile') {
                return;
            }
            //Self
            this.$refs['_searchBox'].classList.add('active');
            //Body
            document.body.classList.add('g-search-box__noscroll');
        },
        mobileDeactive() {
            //Mobile
            if (this.mode !== 'mobile') {
                return;
            }
            //Self
            this.$refs['_searchInput'].blur();
            this.$refs['_searchBox'].classList.remove('active');
            //Body
            document.body.classList.remove('g-search-box__noscroll');
        }
    }
    // #endregion
});
// #endregion
